import React from 'react';
import { useSignPEPPresenter } from './SignPEP.presenter';

import { MainSMSVerification } from './MainSMSVerification/MainSMSVerification';
import { SecondarySMSVerification } from './SecondarySMSVerification/SecondarySMSVerification';
import { DocumentsLinks } from './DocumentsLinks/DocumentsLinks';
import { BadgeStatus } from './BadgeStatus/BadgeStatus';
import { FinalModal } from './FinalModal/FinalModal';
import { Spinner } from 'components/uikit/Spinner/Spinner';

import { VOID_FUNCTION } from 'constants/index';
import { DOCUMENTS_NAMES, TELEPONY_NOTIFICATION } from './constants';

import * as S from './SignPEP.styles';

export const SignPEP = ({ anketaData, anketaErrors, onSave = VOID_FUNCTION }) => {
  const presenter = useSignPEPPresenter({ anketaData, anketaErrors, onSave });

  return (
    <>
      <S.Container data-test="BlockSignPEP">
        <S.TitleWrap>
          <S.Title>Подписание согласия у клиента</S.Title>
          <BadgeStatus />
        </S.TitleWrap>
        <S.Text>{presenter.getNotificationText}</S.Text>
        {!presenter.isPEPSignature && (
          <S.StyledAttentionCard
            title={TELEPONY_NOTIFICATION.title}
            text={TELEPONY_NOTIFICATION.description}
          />
        )}
        <S.Content>
          <S.CheckBox
            name={DOCUMENTS_NAMES.PEP.name}
            disabled={presenter.isPEPSignature}
            value={presenter.data[DOCUMENTS_NAMES.PEP.name]}
            onChange={() => presenter.changeHandler(DOCUMENTS_NAMES.PEP.name)}
            dataTest={DOCUMENTS_NAMES.PEP.name}
          >
            {presenter.getDocumentsLabel(DOCUMENTS_NAMES.PEP.label)}
          </S.CheckBox>

          <S.CheckBox
            name={DOCUMENTS_NAMES.PersonalData.name}
            disabled={presenter.isPEPSignature}
            value={presenter.data[DOCUMENTS_NAMES.PersonalData.name]}
            onChange={() => presenter.changeHandler(DOCUMENTS_NAMES.PersonalData.name)}
            dataTest={DOCUMENTS_NAMES.PersonalData.name}
          >
            {presenter.getDocumentsLabel(DOCUMENTS_NAMES.PersonalData.label)}
          </S.CheckBox>

          <S.CheckBox
            name={DOCUMENTS_NAMES.BKI.name}
            disabled={presenter.isPEPSignature}
            value={presenter.data[DOCUMENTS_NAMES.BKI.name]}
            onChange={() => presenter.changeHandler(DOCUMENTS_NAMES.BKI.name)}
            dataTest={DOCUMENTS_NAMES.BKI.name}
          >
            {presenter.getDocumentsLabel(DOCUMENTS_NAMES.BKI.label)}
          </S.CheckBox>
        </S.Content>

        {!presenter.isPEPSignature && (
          <S.SignButton onClick={presenter.signHandler} disabled={presenter.isDisabled}>
            {presenter.isTeleponyRequestFetching ? (
              <Spinner theme={'2'} size={'l'} />
            ) : (
              'Отправить на подписание'
            )}
          </S.SignButton>
        )}
        <DocumentsLinks />
      </S.Container>

      {presenter.mainVerification && (
        <MainSMSVerification
          appId={anketaData?.application?.id}
          dealerId={anketaData?.application?.dealer?.id}
          customer={presenter.customer}
          onClick={presenter.onMainSMSClickHandler}
          onClose={presenter.verificationCloseHandler}
        />
      )}

      {presenter.secondaryVerification && (
        <SecondarySMSVerification
          appId={anketaData?.application?.id}
          dealerId={anketaData?.application?.dealer?.id}
          customer={presenter.customer}
          onClose={presenter.verificationCloseHandler}
          onSuccess={presenter.verificationSuccessHandler}
        />
      )}

      {presenter.isSuccess && <FinalModal onClose={presenter.closeSuccessPopupHandler} />}

      {presenter.fetchError && (
        <FinalModal error={presenter.fetchError} onClose={presenter.closeSuccessPopupHandler} />
      )}
    </>
  );
};
